<template>
    <div class="page-banner page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">首页导航</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>导航管理</el-breadcrumb-item>
                            <el-breadcrumb-item>首页导航</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleBanner('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="name" align="center" label="导航名" min-width="120"></el-table-column>
                            <el-table-column prop="image_url" align="center" label="导航图片" min-width="120">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="baseUrl + scope.row.image_url" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.image_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="page" align="center" label="跳转分类ID" min-width="140">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.page"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sort" align="center" label="排序" min-width="120">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="120">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleBanner('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteBanner(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export banner-dialog" :title="dlg_banner.title" :visible.sync="dlg_banner.visible" width="534px" @closed="closeBanner" :close-on-click-modal="false">
            <el-form ref="formBanner" :model="dlg_banner.form" label-width="110px" :rules="dlg_banner.rules" @submit.native.prevent>
                <el-form-item prop="name" label="导航名：" :error="dlg_banner.error.name">
                    <el-input size="small" v-model="dlg_banner.form.name" placeholder='请输入导航名' clearable></el-input>
                </el-form-item>
				<el-form-item prop="image_url" style="margin-top: 15px;" label="导航图：" :error="dlg_banner.error.image_url">
                    <el-upload
                            :action="dlg_banner.params.action"
                            :headers="dlg_banner.params.headers"
                            :data="dlg_banner.params.data"
                            accept="image/png,image/jpeg,image/jpg"
                            :class="dlg_banner.hide_upload?'hide-upload head-upload':'head-upload'"
                            list-type="picture-card"
                            :file-list="dlg_banner.img_list"
                            name="file"
                            :on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
                            :on-remove="removeImg"
                            :on-success="uploadSuccessImg">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <p class="img-tips">图片尺寸：450px*450px（请上传小于1M的图片）</p>
                </el-form-item>
                <el-form-item prop="page" label="跳转分类ID：" :error="dlg_banner.error.page">
                    <el-input size="small" v-model="dlg_banner.form.page" placeholder='请输入跳转分类ID' clearable></el-input>
                </el-form-item>
                <el-form-item prop="sort" label="排序：" :error="dlg_banner.error.sort">
                    <el-input size="small" type='number' v-model="dlg_banner.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                </el-form-item>
                <el-form-item prop="status" label="状态：" :error="dlg_banner.error.status">
                    <el-radio-group v-model="dlg_banner.form.status">
                        <el-radio v-for="(item, index) in dlg_banner.init_data.status_list" :key="index" :label="item.id">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_banner.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitBanner()" :loading="dlg_banner.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            var valiImg = (rule, value, callback) =>
            {
                if (!this.dlg_banner.hide_upload) {
                    callback(new Error("请上传导航图"));
                } else {
                    callback();
                }
            };
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                baseUrl:this.$client.IMG_URL,
                //搜索
                form_search:{
                    name:"",
                    status: -1
                },
                init_data: {
                    status_list: [{id:-1, name: '全部'},{id:0, name: '禁用'},{id:1, name: '启用'}],
                },
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_banner:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    hide_upload: false,
                    img_list: [],
                    form:{
						name:'',
                        image_url:'',
                        page:'',
                        sort:'',
                        status:1
                    },
                    error:{
						name:'',
                        image_url:'',
                        page:'',
                        sort:'',
                        status:''
                    },
                    reset_form: {},
                    init_data:{
                        status_list: []
                    },
                    rules:{
						name:{required: true, message: '请输入名称（4个数字已内）', trigger: ['change','blur']},
                        image_url:{required: true, validator: valiImg},
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']},
                        status:{required: true, message: '请选择状态', trigger: ['change','blur']},
                    },
                    params:{
                        action: this.$client.API_URL+'/adminapi/upload/images',
                        data:{path:'banner'},
                        headers:{token:localStorage.getItem('token')}
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '首页banner';
            this.dlg_banner.reset_form = Object.assign({}, this.dlg_banner.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = {};
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                //var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/topnav/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_banner.init_data.status_list = res.status_name_list;
                    //_this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            uploadSuccessImg(res, file, fileList){
                this.dlg_banner.img_list = fileList;
                this.dlg_banner.form.image_url = res.data.file_url;
                this.dlg_banner.hide_upload = true;
            },
            removeImg(file, fileList){
                this.dlg_banner.form.image_url = '';
                this.dlg_banner.img_list = [];
                this.dlg_banner.hide_upload = false;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的banner");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/topnav/delete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },

            handleBanner(type,data){
                this.dlg_banner.visible = true;
                if(type == 'add'){
                    this.dlg_banner.title = '添加banner';
                    this.dlg_banner.api = '/adminapi/topnav/save';
                }else{
                    this.dlg_banner.id= data.id;
                    this.dlg_banner.title = '编辑banner';
                    if(data){
                        for(var key in this.dlg_banner.form){
                            this.dlg_banner.form[key] = data[key];
                        }
                        if(data.image_url){
                            this.dlg_banner.img_list = [{name: 'banner图', url: this.baseUrl + data.image_url}];
                            this.dlg_banner.hide_upload = true;
                        }else{
                            this.dlg_banner.img_list = [];
                            this.dlg_banner.hide_upload = false;
                        }
                    }
                    this.dlg_banner.api = '/adminapi/topnav/save?id=' + data.id;
                }
            },
            deleteBanner(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/topnav/delete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            submitBanner(){
                var _this = this;
                _this.$refs['formBanner'].validate((valid) => {
                    if (valid) {
                        this.dlg_banner.btn_loading = true;
                        this.$client.post(this.dlg_banner.api, this.dlg_banner.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_banner.btn_loading = false;
                            _this.dlg_banner.visible = false;
                        }, function(message){
                            _this.dlg_banner.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_banner.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeBanner(){
                this.dlg_banner.img_list = [];
                this.dlg_banner.hide_upload = false;
                for(var key in this.dlg_banner.form){
                    this.dlg_banner.form[key] = this.dlg_banner.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formBanner.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-banner .el-upload--picture-card{
        line-height: 80px;
    }
    .page-banner .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
</style>
<style scoped>
    .img-tips{
        color: #f31a5c;
        font-size: 12px;
    }
</style>